export { ErrorSection, type ErrorSectionProps } from './error-section';
